import { render, staticRenderFns } from "./sharedAccordian.vue?vue&type=template&id=46a2b799&scoped=true&"
import script from "./sharedAccordian.vue?vue&type=script&lang=tsx&"
export * from "./sharedAccordian.vue?vue&type=script&lang=tsx&"
import style0 from "./sharedAccordian.vue?vue&type=style&index=0&id=46a2b799&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46a2b799",
  null
  
)

export default component.exports